module.exports = __webpack_public_path__ + "img/Faroe Islands.62e0a45b.svg";